import * as React from 'react';
import { useLoadNativeAd } from '../hooks/native';
import {
    NativeAdObj,
    Status,
    DeviceType,
    Vertical,
    Subvertical,
    PageType,
    Features,
} from '../../shared/types/ast';
import { Content, NativeVideo, NewConstruction, Netboard } from '.';
import { getDeviceType } from '../utils/device';

type Props = {
    adObj: NativeAdObj;
    status: Status;
    id: string;
    className?: string;
    grid: boolean;
    vertical?: Vertical;
    subvertical?: Subvertical;
    pageType?: PageType;
    deviceType: DeviceType;
    features?: Features;
};

function getNativeType(adObj: NativeAdObj) {
    if (adObj.native) {
        if (adObj.native.video && adObj.native.video.content) {
            return 'video';
        }
        if (adObj.native.desc2) {
            return adObj.native.desc2;
        }
        if (adObj.native.custom) {
            return adObj.native.custom.type;
        }
    }
    return '';
}

export function Native(props: Props) {
    const {
        adObj,
        id,
        className,
        status,
        vertical,
        subvertical,
        pageType,
        deviceType,
        grid,
    } = props;

    useLoadNativeAd(adObj, status);
    const type = getNativeType(adObj);

    let defaultClassName = 'ads__unit ads__unit--native';
    switch (type) {
        case 'content':
            const list = !grid && deviceType !== 'mobile';
            defaultClassName =
                'ads__unit ads__unit--native ads__unit--fullwidth';
            if (list) {
                defaultClassName =
                    'ads__unit ads__unit--native ads__unit--fullwidth u-pa0';
            }
            if (subvertical === 'holiday_rental') {
                defaultClassName =
                    'ads__unit ads__unit--native ads__unit--fullwidth u-pa0 u-pb16';
            }
            return (
                <div
                    id={id}
                    className={className || defaultClassName}
                    style={{ display: 'block' }}
                >
                    <Content adObj={adObj} list={list} />
                </div>
            );
        case 'video':
            return (
                <div
                    id={id}
                    className={
                        className ||
                        'ads__unit ads__unit--native ads__unit--fullwidth'
                    }
                >
                    <NativeVideo
                        adObj={adObj}
                        mobile={getDeviceType() === 'mobile'}
                    />
                </div>
            );
        case 'afsh':
            return (
                <div
                    id={id}
                    className={className || 'ads__unit ads__unit--native afsh'}
                ></div>
            );
        case 'prisjakt':
            return (
                <div
                    id={id}
                    className={
                        className || 'ads__unit ads__unit--native prisjakt'
                    }
                ></div>
            );
        case 'nybygg':
            return (
                <div
                    id={id}
                    className={className || 'ads__unit ads__unit--native'}
                >
                    <NewConstruction
                        adObj={adObj}
                        grid={grid}
                        vertical={vertical}
                    />
                </div>
            );

        default:
            if (subvertical === 'holiday_rental') {
                defaultClassName = 'ads__unit ads__unit--native u-pa0 u-pb16';
            }
            if (subvertical === 'flight') {
                defaultClassName = 'ads__unit ads__unit--native u-pv32';
            }
            if (subvertical === 'prepackage') {
                if (pageType === 'object') {
                    if (deviceType === 'mobile') {
                        defaultClassName = 'u-mh0 u-mv16';
                    } else {
                        defaultClassName = 'ads__unit ads__unit--native u-pa0';
                    }
                } else {
                    defaultClassName = 'ads__unit ads__unit--native u-pa2';
                }
            }

            return (
                <div id={id} className={className || defaultClassName}>
                    <Netboard
                        adObj={adObj}
                        troika={true}
                        grid={grid}
                        vertical={vertical}
                        subvertical={subvertical}
                        pageType={pageType}
                        deviceType={deviceType}
                    />
                </div>
            );
    }
}
